/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, days: NonNullable<unknown> }} Notif_Debt_Overdue_SummaryInputs */

const vi_notif_debt_overdue_summary = /** @type {(inputs: Notif_Debt_Overdue_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn nợ ${i?.amount} · quá hạn ${i?.days} ngày`)
};

/**

* @param {Notif_Debt_Overdue_SummaryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_debt_overdue_summary = /** @type {((inputs: Notif_Debt_Overdue_SummaryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Debt_Overdue_SummaryInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_debt_overdue_summary(inputs)
});